import React from 'react'
import Chip from '@mui/material/Chip'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { withStyles } from '~/themes/useStyles'
import { COLORS } from '~/themes/common'

const TagItem = withStyles((theme) => ({
  root: {
    height: 32,
    fontSize: 14,
    borderRadius: 5,
    border: `1px solid ${COLORS.gray.darkGray}`,
    margin: theme.spacing(0.5),
    maxWidth: '95%',
    backgroundColor: '#ffffff',
    '& span': {
      width: '100%',
    },
    '&.Mui-disabled': {
      opacity: 1,
    },
  },
}))((props) => <Chip {...props} />)

const TagList = withStyles((theme) => ({
  tagContainer: {
    backgroundColor: COLORS.palette.secondaryBlue3,
    borderRadius: 5,
    border: `1px solid ${COLORS.palette.secondaryBlue2}`,
    padding: theme.spacing(0.5),
  },
  disabled: {
    backgroundColor: COLORS.gray.disableGray2,
    borderColor: 'rgba(0, 0, 0, 0.23)',
  },
}))(
  ({
    classes,
    tags, // [{ value: '', label: '' }]
    onChange, // (allTags: []) => {}
    flexibleHeight,
    style,
    renderTagView,
    disabled,
  }) => {
    const onRemove = (id) => {
      const newTagList = tags
      newTagList.splice(id, 1)
      onChange([...newTagList])
    }

    return (
      <div
        className={clsx(classes.tagContainer, 'customized-scrollbar', {
          [classes.disabled]: disabled,
        })}
        style={{
          minHeight: flexibleHeight && 169,
          height: !flexibleHeight && 169,
          overflowY: 'auto',
          ...style,
        }}
      >
        {tags.map((item, index) =>
          renderTagView ? (
            renderTagView({ data: item, idx: index, onRemove })
          ) : (
            <TagItem
              key={index}
              label={item.label}
              onDelete={() => onRemove(index)}
              disabled={disabled}
              deleteIcon={
                <img
                  src="/icons/close.svg"
                  style={{
                    width: 10,
                    paddingLeft: 3,
                    paddingRight: 3,
                    opacity: disabled ? 0.3 : 1,
                  }}
                  alt="remove"
                />
              }
            />
          ),
        )}
      </div>
    )
  },
)

TagList.defaultProps = {
  tags: [],
  onChange: () => {},
  renderTagView: undefined,
  disabled: false,
}

TagList.propTypes = {
  classes: PropTypes.shape(),
  tags: PropTypes.arrayOf(PropTypes.shape()),
  onChange: PropTypes.func,
  renderTagView: PropTypes.func,
  flexibleHeight: PropTypes.bool,
  disabled: PropTypes.bool,
  props: PropTypes.shape(),
}

export default TagList
